// KWANKGM04080_契約申込確認_契約内容
import React from 'react';
import HeadingM from '../molecules/HeadingM';
import Text from '../molecules/Text';
import Annotation from '../atoms/Annotation';
import { ContractInfo } from '../types/Template';

interface Props {
  contract_info: ContractInfo;
  looks_inactive: boolean;
}

const ContractApplicationConfirmationBody: React.FC<Props> = ({
  contract_info,
  looks_inactive,
}) => {
  return (
    <>
      <HeadingM label="契約内容確認" />
      <Annotation text="契約内容を確認して下さい。" />
      <div>
        <Text
          disabled={true}
          handleChange={() => {}}
          id="loan-scheduled-date"
          label="実行予定日"
          placeholder=""
          value={contract_info.loan_scheduled_date}
          looks_inactive={looks_inactive}
        />
        <Text
          disabled={true}
          handleChange={() => {}}
          id="planned-borrowing-amount"
          label="借入金額"
          placeholder="planned-borrowing-amount"
          value={contract_info.planned_borrowing_amount}
          suffix="円"
          looks_inactive={looks_inactive}
        />
      </div>
      <HeadingM label="契約方式" />
      <Annotation text="契約方式を確認して下さい。" />
      <div>
        <Text
          disabled={true}
          handleChange={() => {}}
          id="desired-econtract"
          label="ご希望の契約方式"
          placeholder="contract-method"
          value={contract_info.desired_econtract}
          looks_inactive={looks_inactive}
        />
      </div>
    </>
  );
};

export default ContractApplicationConfirmationBody;
